import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Typography } from '@mui/material';
import Button from '@mui/material/Button';

import DrawerBody from './DrawerBody';
import DrawerFooter from './DrawerFooter';
import { DrawerComponentProps } from './DrawerManager';
import DrawerTitle from './DrawerTitle';
import { useAnalytics } from 'src/AnalyticsContext';
import { Drawers } from 'src/constants/Drawers';
import useShiftInstances from 'src/hooks/useShiftInstances';
import { setHasOpenedDriftDrawer } from 'src/store/globalUISlice';

const ShiftDriftDrawer = (props: DrawerComponentProps) => {
    const { onNext, onClose } = props;
    const dispatch = useDispatch();
    const { trackEvent } = useAnalytics();
    const { selectedShift, currentTimeShift, offShiftDirection } = useShiftInstances();

    useEffect(() => {
        dispatch(setHasOpenedDriftDrawer(true));
    }, [dispatch]);

    const selectedShiftName = selectedShift?.name ?? 'your selected shift';
    const currentShiftName = currentTimeShift?.name ?? 'the current shift';

    const title =
        offShiftDirection === 'future'
            ? 'You are viewing tasks from a future shift'
            : 'You are viewing tasks from a past shift';

    const handleChangeShift = () => {
        trackEvent('Shift Drift Change Shift Clicked', {
            selectedShiftId: selectedShift?.id,
            currentShiftId: currentTimeShift?.id,
        });
        onNext({}, { type: Drawers.SelectShift });
    };

    const handleStay = () => {
        trackEvent('Shift Drift Stay Clicked', {
            selectedShiftId: selectedShift?.id,
            currentShiftId: currentTimeShift?.id,
        });
        onClose();
    };

    return (
        <>
            <DrawerTitle>
                <Typography variant="h3" sx={{ fontWeight: 'bold' }}>
                    {title}
                </Typography>
            </DrawerTitle>

            <DrawerBody sx={{ pt: 1, gap: 2 }}>
                <Typography variant="body1">
                    <Typography component="span" variant="body1" sx={{ fontWeight: 'bold' }}>
                        Your Sage phone is set to {selectedShiftName}.
                    </Typography>{' '}
                    To document tasks from{' '}
                    <Typography component="span" variant="body1" sx={{ fontWeight: 'bold' }}>
                        {currentShiftName},
                    </Typography>{' '}
                    change your shift below.
                </Typography>
            </DrawerBody>

            <DrawerFooter sx={{ pt: 1, gap: 2 }}>
                <Button
                    variant="contained"
                    onClick={handleChangeShift}
                    sx={{ fontSize: 'body1.fontSize' }}
                >
                    Change Shift
                </Button>
                <Button variant="outlined" onClick={handleStay} sx={{ fontSize: 'body1.fontSize' }}>
                    Stay in {selectedShiftName}
                </Button>
            </DrawerFooter>
        </>
    );
};

export default ShiftDriftDrawer;
